import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fileInput", "uploadBtn", "copyButtons", "form"]

  connect() {
    this.setupFileValidation()
    this.setupClipboardFunctionality()
    this.setupFormValidation()
  }

  setupFileValidation() {
    this.fileInputTarget.addEventListener('change', this.validateFile.bind(this))
  }

  validateFile(event) {
    const file = event.target.files[0]
    const maxSize = 100 * 1024 * 1024 // 100MB

    if (file && file.name.toLowerCase().endsWith('.apk')) {
      if (file.size > maxSize) {
        event.target.setCustomValidity('File size must be less than 50MB')
        this.uploadBtnTarget.disabled = true
      } else {
        event.target.setCustomValidity('')
        this.uploadBtnTarget.disabled = false
      }
    } else {
      event.target.setCustomValidity('Please select a valid APK file')
      this.uploadBtnTarget.disabled = true
    }
  }

  setupClipboardFunctionality() {
    this.copyButtonsTargets.forEach(button => {
      button.addEventListener('click', this.copyToClipboard.bind(this))
    })
  }

  copyToClipboard(event) {
    const button = event.target.closest('[data-clipboard-text]')
    const text = button.getAttribute('data-clipboard-text')

    navigator.clipboard.writeText(text).then(() => {
      const icon = button.querySelector('i')
      const originalClass = icon.className
      icon.className = 'bi bi-check'

      setTimeout(() => {
        icon.className = originalClass
      }, 2000)
    }).catch(() => {
      // Fallback for older browsers
      this.fallbackCopyToClipboard(text, button)
    })
  }

  fallbackCopyToClipboard(text, button) {
    const textArea = document.createElement('textarea')
    textArea.value = text
    textArea.style.position = 'fixed'
    textArea.style.opacity = '0'
    document.body.appendChild(textArea)
    textArea.select()

    try {
      document.execCommand('copy')
      const icon = button.querySelector('i')
      const originalClass = icon.className
      icon.className = 'bi bi-check'

      setTimeout(() => {
        icon.className = originalClass
        document.body.removeChild(textArea)
      }, 2000)
    } catch (err) {
      document.body.removeChild(textArea)
      console.error('Failed to copy text: ', err)
    }
  }

  setupFormValidation() {
    this.formTarget.addEventListener('submit', this.validateForm.bind(this))
  }

  validateForm(event) {
    if (!this.formTarget.checkValidity()) {
      event.preventDefault()
      event.stopPropagation()
    }
    this.formTarget.classList.add('was-validated')
  }

  // Action handlers for Turbo/Stimulus events
  beforeSubmit(event) {
    const button = event.target
    button.disabled = true
    button.querySelector('[data-disable-with]')?.remove()

    const originalText = button.textContent
    button.innerHTML = '<span class="spinner-border spinner-border-sm me-2"></span>Uploading...'

    setTimeout(() => {
      button.disabled = false
      button.textContent = originalText
    }, 60000) // Reset after 60 seconds if no redirect occurs
  }

  onSuccess(event) {
    console.log('APK upload successful')
    // Flash message will be handled by Rails
  }

  onError(event) {
    console.log('APK upload failed')
    // Error handling will be handled by Rails flash messages
  }
}
